export const parsePhone = (phone?: string) => phone?.replace(/\D/g, '') ?? '';
